import { render, staticRenderFns } from "./menuReception.vue?vue&type=template&id=dc35ede2&scoped=true&"
import script from "./menuReception.vue?vue&type=script&lang=js&"
export * from "./menuReception.vue?vue&type=script&lang=js&"
import style0 from "./menuReception.vue?vue&type=style&index=0&id=dc35ede2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc35ede2",
  null
  
)

export default component.exports